export interface IOrganisation {
  id: number;
  name: string;
  addressLines: string[];
  telephone: string;
  endComment: string;
  website: string;
  logo: string;
  organisationType: string;
}

export const defaultOrganisation: IOrganisation = {
  id: 0,
  name: "",
  addressLines: [],
  telephone: "",
  endComment: "",
  website: "",
  logo: "",
  organisationType: "",
};
